import { useStage } from './useStage'

export default function() {
  return useStage('ach-payment')
}
